module.exports = __webpack_public_path__ + "static/work45-54cec673758a50830c8d511182461a13.jpg";